import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-conditions-partner-license',
  templateUrl: './terms-conditions-partner-license.component.html',
  styleUrls: ['./terms-conditions-partner-license.component.scss']
})
export class TermsConditionsPartnerLicenseComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}